import {ApplicationStoreType} from 'reducers';

/**
 * Return wizardMs state
 *
 * @param {ApplicationStoreType} store - redux store
 * @returns {*} wizardMS state
 */
export const getWizardMs = (store: ApplicationStoreType) => store.wizardMs;

/**
 * Selector for wizardData
 * @param {ApplicationStoreType} store - redux store
 * @returns {boolean} wizardData isSafety
 */
export const getIsSafety = (store: ApplicationStoreType): boolean =>
    getWizardMs(store).wizardData.isSafety;
